const GetPendingRequestAproved = (thiss, Options, type = "any") => {
  //   console.log("dsdsad");
  let isRRHH =
    thiss.currentUser.EmployeeId == 37 ||
    thiss.IsInRoles([thiss.roles.GerenteRRHH])
      ? true
      : false;
  let params = {
    Option: Options,
    Year: thiss.year,
    EmployeeID: isRRHH ? 0 : thiss.currentUser.EmployeeId,
    type: type
  };
  thiss.$http
    .get("/api/Modules/GetPendingRequestAproved", { params })
    .then((resp) => {
      thiss.PeddingRequestAproveRRRHH = resp.data.PeddingRequestAproveRRRHH;
      thiss.PeddingRequestAproveSuper = resp.data.PeddingRequestAproveSuper;
    })
    .finally(() => {
      thiss.autoLoading = false;
    });
};

export default GetPendingRequestAproved;
